export const TaktApiMapConfig = {
  getCampaigns: {
    provider: 'urc-bff' as const,
    operation: 'get-campaigns' as const
  },
  getCampaignsInfinite: {
    provider: 'urc-bff' as const,
    operation: 'get-campaigns' as const
  },
  queryAccountHierarchies: {
    provider: 'urc-bff' as const,
    operation: 'get-account-hierarchies' as const
  },
  listFlexibleReportConfigurations: {
    provider: 'ross' as const,
    operation: 'list-subscriptions' as const
  },
  createFlexibleReportConfiguration: {
    provider: 'ross' as const,
    operation: 'create-subscription' as const
  },
  getFlexibleReportConfiguration: {
    provider: 'ross' as const,
    operation: 'get-subscription' as const
  },
  updateFlexibleReportConfiguration: {
    provider: 'ross' as const,
    operation: 'update-subscription' as const
  },
  deleteFlexibleReportConfiguration: {
    provider: 'ross' as const,
    operation: 'delete-subscription' as const
  },
  runFlexibleReport: {
    provider: 'ross' as const,
    operation: 'run-report' as const
  },
  listFlexibleScheduledReports: {
    provider: 'ross' as const,
    operation: 'list-reports' as const
  },
  queryReportingFields: {
    provider: 'metadata' as const,
    operation: 'query-reporting-fields' as const
  },
  listTemplates: {
    provider: 'template' as const,
    operation: 'list-templates' as const
  },
  getTemplates: {
    provider: 'template' as const,
    operation: 'get-templates' as const
  }
};
